/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  resolveReferenceRequest: components.ResolveReferenceRequest;
};

/** @internal */
export const ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest$inboundSchema:
  z.ZodType<
    ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    "X-On-Behalf-Of": z.string().optional(),
    ResolveReferenceRequest: components.ResolveReferenceRequest$inboundSchema,
  }).transform((v) => {
    return remap$(v, {
      "X-On-Behalf-Of": "xOnBehalfOf",
      "ResolveReferenceRequest": "resolveReferenceRequest",
    });
  });
/** @internal */
export type ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest$Outbound =
  {
    "X-On-Behalf-Of"?: string | undefined;
    ResolveReferenceRequest: components.ResolveReferenceRequest$Outbound;
  };

/** @internal */
export const ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest$outboundSchema:
  z.ZodType<
    ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest$Outbound,
    z.ZodTypeDef,
    ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest
  > = z.object({
    xOnBehalfOf: z.string().optional(),
    resolveReferenceRequest: components.ResolveReferenceRequest$outboundSchema,
  }).transform((v) => {
    return remap$(v, {
      xOnBehalfOf: "X-On-Behalf-Of",
      resolveReferenceRequest: "ResolveReferenceRequest",
    });
  });

export function resolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequestToJSON(
  resolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest:
    ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest,
): string {
  return JSON.stringify(
    ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest$outboundSchema
      .parse(resolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest),
  );
}
export function resolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest' from JSON`,
  );
}
